import React from 'react';
import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel';

const RightSideLayout1 = () => {
	return (
		<>
			<QuickPanel />
		</>
	);
};

export default React.memo(RightSideLayout1);
